/* ============================================================
   NATIVE EX/INC VAT PRICE DISPLAY (14 Oct 2026, ex-VAT switch —
   _project/multistore/exvat-switch/DUAL-PRICE-NATIVE.md).

   Replaces the Dual Price Display PRO app. Loaded (deferred, right after
   custom.js) by a DSS HOOK in layout/theme.liquid ONLY when Theme settings
   → "Native Ex/Inc VAT price display" (dss_dual_native) is ticked; with
   it unticked this file is never requested and the app does the job as
   before. custom-tokens.liquid prints window.DSS_DUAL (settings, NOVAT,
   customer country) and resolves the country synchronously so
   html.dss-dual-single is on <html> before first paint.

   WHAT IT DOES
   The shop money format still wraps every `| money` as
   <span class=dualPrice>£53.15</span>. For the PRODUCT prices the app used
   to decorate, this module rewrites that span into the app's own markup:
     <span class="dualPrice dp_detail|dp_catalog dss-dp-done">
       [<span class="dpCompareAtPrice"><span data-dss-raw>£X<span class="dss-dp-cmplbl"> Ex VAT</span></span></span><br>]
       <span class="secondPrice"><span class="secondPriceValue">£44.29</span> <span class="secondPriceLabel">Ex VAT</span></span><br>
       <span class="firstPrice"><span class="firstPriceValue">£53.15</span> <span class="firstPriceLabel">Inc VAT</span></span>
     </span>
   so every existing Dual Price rule in custom.css (and the store templates'
   own custom CSS) styles it exactly as before. Contexts (the ones the app
   reached, nothing else — the header basket pill, bars, unit prices and
   account pages stay as plain figures, as they always did):
     - PDP / quick view / sticky bar price block (.product-block--price):
       sale → the block goes into the struck compare-at span and the bare
       price span is hidden (the app removed it) — the WSS app-era markup.
     - product cards (.grid-product__price — collections, search template,
       recommendations, recently viewed, shoppable hero), same sale rule.
     - trending cards without a variant (.dss-tp__money), cart DRAWER lines
       (from data-dss-unit-price, the line's own variant — the app used the
       product's cheapest and custom.js had to police it).
     - Searchanise result cards (.snize-price) — the desktop quick-view
       fast path in custom.js still decorates the cards it owns.
     - anything else inside a product link (the app's own catch-all).
   ALL maths through window.DSS_VAT (ex()/inc(), dss_vat_basis) — so the
   figures follow the store's tax setting exactly like every other theme
   price. Zero-rated variants (taxable false): one figure, no label
   (.nonTaxableVariant, the app's class). Taxability: data-dss-taxable
   printed by Liquid on cards/cart lines/trending; the product's
   [data-variant-json] for PDP/quick view/sticky; /products/<handle>.js for
   anything else (cached).

   SINGLE MODE (visitor not in the UK, NOVAT login, non-UK default
   address): html.dss-dual-single — custom.css hides the Inc line, every
   label and the UK-only lines under the price. The markup is identical in
   both modes, so a late country answer only toggles the class.

   COUNTRY: DSS_DUAL.resolved (inline in custom-tokens: ?dss_country=XX
   override → customer default address → non-UK Markets country → cached
   geolocation). If still unknown: Shopify's own same-origin
   /browsing_context_suggestions.json (detected_values.country.handle),
   cached in sessionStorage. UK (dual) until known. Test: ?dss_country=FR
   (kept for the tab; ?dss_country=clear to reset).
   ============================================================ */
(function () {
  'use strict';
  var D = window.DSS_DUAL;
  if (!D || !D.native) return;
  var V = window.DSS_VAT;
  var html = document.documentElement;
  var LBL = D.labels || { ex: 'Ex VAT', inc: 'Inc VAT' };
  var UK = D.uk || ['GB', 'IM'];
  var INC_FIRST = D.first === 'inc';

  function money(p) {
    return '£' + (Math.round(p) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  /* "£1,706.40" → 170640 */
  function pence(text) {
    var m = String(text || '').replace(/[^\d.,]/g, '').match(/(\d[\d.,]*)/);
    if (!m) return null;
    var n = Math.round(parseFloat(m[1].replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.')) * 100);
    return isNaN(n) ? null : n;
  }

  /* The app supplied Shopify.formatMoney + dp_money_format; older custom.js
     paths (Searchanise fast path) still call them. GBP-only stores. */
  window.Shopify = window.Shopify || {};
  if (typeof window.Shopify.formatMoney !== 'function') {
    window.Shopify.formatMoney = function (c) {
      if (typeof c === 'string') c = c.replace('.', '');
      return money(Number(c));
    };
  }
  if (!window.dp_money_format) window.dp_money_format = '£{{amount}}';

  /* ---------- the markup (the app's, labels from the theme settings) ---------- */
  function blockHTML(stored, taxable, cmpStored) {
    var ex = Math.round(V.ex(stored, taxable)), inc = Math.round(V.inc(stored, taxable));
    var exH = '<span class="secondPrice"><span class="secondPriceValue">' + money(ex) + '</span> <span class="secondPriceLabel">' + esc(LBL.ex) + '</span></span>';
    var incH = '<span class="firstPrice" style="color:#000000"><span class="firstPriceValue">' + money(inc) + '</span> <span class="firstPriceLabel">' + esc(LBL.inc) + '</span></span>';
    var cmp = '';
    if (cmpStored && cmpStored > stored) {
      /* struck compare-at on the SAME basis as the lead line (what fixCompare used to correct after the app) */
      var c = Math.round(INC_FIRST ? V.inc(cmpStored, taxable) : V.ex(cmpStored, taxable));
      cmp = '<span class="dpCompareAtPrice" style="text-decoration: line-through;"><span data-dss-raw="' + (cmpStored / 100) + '">' +
        money(c) + '<span class="dss-dp-cmplbl"> ' + esc(INC_FIRST ? LBL.inc : LBL.ex) + '</span></span></span><br>';
    }
    return cmp + (INC_FIRST ? incH + '<br>' + exH : exH + '<br>' + incH);
  }

  /* the app sized the second line at lead ÷ 1.5 inline; custom.css overrides it
     with !important in most places — kept so the rest look exactly as before */
  function sizeSecond(el) {
    var lead = el.querySelector(INC_FIRST ? '.firstPrice' : '.secondPrice');
    var other = el.querySelector(INC_FIRST ? '.secondPrice' : '.firstPrice');
    if (!lead || !other) return;
    var fs = parseInt(getComputedStyle(lead).fontSize, 10);
    if (fs > 0) other.style.fontSize = (fs / 1.5) + 'px';
  }

  function done(el) { el.classList.add('dss-dp-done'); }

  function render(el, type, stored, taxable, cmpStored) {
    el.setAttribute('data-dss-stored', stored);
    if (taxable === false) {                       /* zero-rated: the stored figure, alone */
      el.classList.add('nonTaxableVariant');
      done(el);
      return;
    }
    done(el);
    el.classList.add(type);
    el.innerHTML = blockHTML(stored, taxable, cmpStored);
    el.style.display = 'block';
    if (el.parentElement) el.parentElement.style.textDecoration = 'none';
    sizeSecond(el);
  }

  function isBare(el) {
    return el && !el.classList.contains('dss-dp-done') && !el.classList.contains('dp_catalog') &&
      !el.classList.contains('dp_detail') && !el.classList.contains('nonTaxableVariant');
  }
  function storedOf(el) {
    var s = el.getAttribute('data-dss-stored');
    return s != null ? parseInt(s, 10) : pence(el.textContent);
  }
  function hiddenByTheme(el) { return !!el.closest('.hide, [hidden]'); }

  /* ---------- taxability ---------- */
  var jsonCache = new WeakMap();
  function variantsIn(root) {
    var ta = root && root.querySelector('[data-variant-json]');
    if (!ta) return null;
    var c = jsonCache.get(ta);
    if (c && c.txt === ta.textContent) return c.v;
    var v = null;
    try { v = JSON.parse(ta.textContent); } catch (e) { v = null; }
    jsonCache.set(ta, { txt: ta.textContent, v: v });
    return v;
  }
  /* nearest ancestor that carries the product's variant JSON (PDP section,
     quick-view holder); the sticky bar borrows the main product section's */
  function productRoot(el) {
    if (el.closest('.sticky-atc')) {
      var main = document.querySelector('[data-product-blocks] .product-block--price');
      if (main) el = main;
    }
    var n = el.parentElement;
    while (n && n !== document.body) {
      if (n.querySelector('[data-variant-json]')) return n;
      n = n.parentElement;
    }
    return null;
  }
  function pickTaxable(vars, id, stored) {
    if (!vars || !vars.length) return true;
    var sel = null;
    for (var i = 0; i < vars.length; i++) if (String(vars[i].id) === String(id)) sel = vars[i];
    if (sel && sel.price === stored) return sel.taxable !== false;
    /* the shown figure is not the selected variant's (mid-switch): use the variants at that price */
    var at = vars.filter(function (v) { return v.price === stored; });
    if (at.length) return at.some(function (v) { return v.taxable !== false; });
    return sel ? sel.taxable !== false : vars[0].taxable !== false;
  }
  function detailTaxable(el, stored) {
    var root = productRoot(el);
    if (!root) return true;
    var vars = variantsIn(root);
    var idEl = root.querySelector('select[name="id"], input[name="id"]');
    return pickTaxable(vars, idEl ? idEl.value : null, stored);
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[handle];
  }
  function handleFrom(el) {
    var a = el.closest('a[href*="/products/"]');
    if (!a) {
      var card = el.closest('.grid-product, .grid__item, li, .dss-tp, [class*="product"]');
      a = card && card.querySelector('a[href*="/products/"]');
    }
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  /* taxable from a Liquid data-dss-taxable flag if one is in reach, else the product JSON */
  function withTaxable(el, scope, stored, cb) {
    var flagEl = el.closest('[data-dss-taxable]') || (scope && scope.querySelector('[data-dss-taxable]'));
    if (flagEl) { cb(flagEl.getAttribute('data-dss-taxable') !== 'false'); return; }
    var handle = handleFrom(el);
    if (!handle) { cb(true); return; }
    el.classList.add('dss-dp-wait');
    fetchProduct(handle).then(function (p) {
      cb(pickTaxable(p.variants, null, stored));
    }, function () { cb(true); });
  }

  /* ---------- contexts ---------- */
  /* PDP / quick view / sticky bar */
  function doDetail(pb) {
    var priceEl = pb.querySelector('[data-product-price] .dualPrice');
    var cmpEl = pb.querySelector('[data-compare-price] .dualPrice');
    if (!priceEl) { if (cmpEl && isBare(cmpEl)) done(cmpEl); return; }
    if (!isBare(priceEl) && !(cmpEl && isBare(cmpEl))) return;
    var stored = storedOf(priceEl);
    if (stored == null) { done(priceEl); if (cmpEl) done(cmpEl); return; }
    var cmpStored = (cmpEl && !hiddenByTheme(cmpEl)) ? storedOf(cmpEl) : 0;
    var taxable = detailTaxable(pb, stored);
    priceEl.classList.remove('dss-dp-dup');
    if (taxable === false) {
      render(priceEl, 'dp_detail', stored, false);
      if (cmpEl) { cmpEl.classList.add('nonTaxableVariant'); done(cmpEl); }
      return;
    }
    if (cmpEl && cmpStored > stored) {
      cmpEl.setAttribute('data-dss-stored', cmpStored);
      render(cmpEl, 'dp_detail', stored, true, cmpStored);
      cmpEl.setAttribute('data-dss-stored', cmpStored);
      priceEl.setAttribute('data-dss-stored', stored);
      priceEl.classList.add('dss-dp-dup');
      done(priceEl);
    } else {
      render(priceEl, 'dp_detail', stored, true, 0);
      if (cmpEl) done(cmpEl);
    }
  }

  /* product cards */
  function cardScope(el) {
    return el.closest('.grid-product__meta, .results-products__info') || el.closest('.grid-product__price') || el.parentElement;
  }
  function doCard(scope) {
    var cmpEl = scope.querySelector('.grid-product__price--original .dualPrice');
    var priceEl = null;
    scope.querySelectorAll('.grid-product__price .dualPrice').forEach(function (s) {
      if (!priceEl && !s.closest('.grid-product__price--original, .grid-product__price--savings, .product__unit-price')) priceEl = s;
    });
    /* savings / unit-price figures: left as the plain figure, as the app left them */
    scope.querySelectorAll('.grid-product__price--savings .dualPrice, .product__unit-price .dualPrice').forEach(done);
    if (!priceEl) { if (cmpEl && isBare(cmpEl)) done(cmpEl); return; }
    if (!isBare(priceEl) && !(cmpEl && isBare(cmpEl))) return;
    if (priceEl.classList.contains('dss-dp-wait')) return;
    var stored = storedOf(priceEl);
    if (stored == null) { done(priceEl); if (cmpEl) done(cmpEl); return; }
    var cmpStored = cmpEl ? storedOf(cmpEl) : 0;
    withTaxable(priceEl, scope, stored, function (taxable) {
      priceEl.classList.remove('dss-dp-wait');
      if (!taxable) {
        render(priceEl, 'dp_catalog', stored, false);
        if (cmpEl) { cmpEl.classList.add('nonTaxableVariant'); done(cmpEl); }
      } else if (cmpEl && cmpStored > stored) {
        render(cmpEl, 'dp_catalog', stored, true, cmpStored);
        cmpEl.setAttribute('data-dss-stored', cmpStored);
        priceEl.setAttribute('data-dss-stored', stored);
        priceEl.classList.add('dss-dp-dup');
        done(priceEl);
      } else {
        render(priceEl, 'dp_catalog', stored, true, 0);
        if (cmpEl) done(cmpEl);
      }
    });
  }

  /* cart drawer line: the line's own unit price + taxable flag from cart-item.liquid */
  function doCartLine(el) {
    var host = el.closest('[data-dss-unit-price]');
    var stored = host ? parseInt(host.getAttribute('data-dss-unit-price'), 10) : pence(el.textContent);
    if (isNaN(stored) || stored == null) { done(el); return; }
    var taxable = !(host && host.getAttribute('data-dss-taxable') === 'false');
    render(el, 'dp_catalog', stored, taxable, 0);
  }

  /* trending card without a variant, and the catch-all inside a product link */
  function doSimple(el, scope) {
    if (el.classList.contains('dss-dp-wait')) return;
    var stored = pence(el.textContent);
    if (stored == null) { done(el); return; }
    withTaxable(el, scope, stored, function (taxable) {
      el.classList.remove('dss-dp-wait');
      if (isBare(el)) render(el, 'dp_catalog', stored, taxable, 0);
    });
  }

  /* Searchanise card: same markup as custom.js's quick-view fast path (no
     .dualPrice class — card CSS keys on .snize-price), from the product JSON */
  function doSnize(span) {
    if (span.classList.contains('dss-dp-wait') || span.classList.contains('dp_catalog')) return;
    var li = span.closest('li.snize-product');
    var handle = li && handleFrom(li.querySelector('a[href*="/products/"]') || span);
    if (!handle) { span.classList.add('dp_catalog'); return; }
    span.classList.add('dss-dp-wait');
    fetchProduct(handle).then(function (p) {
      span.classList.remove('dss-dp-wait');
      if (span.classList.contains('dp_catalog') || span.querySelector('.secondPrice')) return;   /* fast path got there first */
      var best = null;
      (p.variants || []).forEach(function (v) { if (typeof v.price === 'number' && (!best || v.price < best.price)) best = v; });
      if (!best) { span.classList.add('dp_catalog'); return; }
      var cmp = best.compare_at_price > best.price ? best.compare_at_price : 0;
      if (best.taxable === false) {
        span.innerHTML = (cmp ? '<span class="dpCompareAtPrice"><span data-dss-raw="' + cmp / 100 + '">' + money(cmp) + '</span></span> ' : '') + money(best.price);
        span.classList.add('dp_catalog', 'nonTaxableVariant');
        return;
      }
      span.innerHTML = blockHTML(best.price, true, cmp).replace(/<br>/g, '');
      span.classList.add('dp_catalog');
    }, function () { span.classList.remove('dss-dp-wait'); span.classList.add('dp_catalog', 'dss-dp-fail'); });
  }

  /* ---------- the pass ---------- */
  var EXCLUDE = '.template-cart #CartPageForm, [data-dss-cart-price], [data-subtotal], .product__unit-price, [data-unit-price], .dss-ship-bar, .dss-min-bar, .customer, .cart__item-sub';
  function pass() {
    var spans = document.querySelectorAll('.dualPrice:not(.dss-dp-done):not(.dp_catalog):not(.dp_detail):not(.nonTaxableVariant)');
    for (var i = 0; i < spans.length; i++) {
      var el = spans[i];
      if (!isBare(el)) continue;   /* a sibling's pass in this loop already handled it */
      var pb = el.closest('.product-block--price');
      if (pb) {
        if (el.closest('[data-product-price], [data-compare-price]')) doDetail(pb); else done(el);
        continue;
      }
      if (el.closest('#CartDrawer [data-key] .cart__price')) { doCartLine(el); continue; }
      if (el.closest(EXCLUDE)) { done(el); continue; }
      if (el.closest('.grid-product__price, .grid-product__price--original')) { doCard(cardScope(el)); continue; }
      var tp = el.closest('.dss-tp__money');
      if (tp) { doSimple(el, tp); continue; }
      if (el.closest('a[href*="/products/"]')) { doSimple(el, null); continue; }
      done(el);   /* not a product price the app ever decorated: leave the plain figure */
    }
    document.querySelectorAll('#snize_results li.snize-product .snize-price:not(.dp_catalog):not(.dss-dp-wait)').forEach(doSnize);
    /* the struck figure is final as written — release the first-paint hide custom.js set for the app-era rescale */
    if (html.classList.contains('dss-price-pending')) html.classList.remove('dss-price-pending');
    qvReserve();
  }

  /* quick view: reserve the two-line price height (custom.css .dss-qv-dualprice) — dual mode only */
  function qvReserve() {
    document.querySelectorAll('.modal--quick-shop').forEach(function (m) {
      m.classList.toggle('dss-qv-dualprice', !D.single);
      /* a quick view opened from a collection sits inside the section whose template CSS hides .firstPrice
         (collection cards show Ex only) — no class selector outranks it, so the Inc line is un-hidden inline,
         as the app-era fpFix did (Sam, 14 Aug). Single mode: let custom.css hide it. */
      m.querySelectorAll('.product-block--price .dualPrice .firstPrice').forEach(function (fp) {
        if (D.single) fp.style.removeProperty('display'); else fp.style.setProperty('display', 'block', 'important');
      });
    });
  }

  /* ---------- country ---------- */
  function setCountry(cc, source) {
    D.resolved = cc || '';
    if (source) D.source = source;
    D.single = D.isSingle ? D.isSingle(D.resolved) : (D.novat || (!!cc && UK.indexOf(cc) < 0));
    html.classList.toggle('dss-dual-single', D.single);
    qvReserve();
    try { document.dispatchEvent(new CustomEvent('dss:dual-mode', { detail: { single: D.single, country: D.resolved, source: D.source } })); } catch (e) {}
  }
  function resolveCountry() {
    if (D.resolved) return;
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!cc) return;
        cc = String(cc).toUpperCase();
        try { sessionStorage.setItem('dss_geo_country', cc); } catch (e) {}
        if (!D.resolved) setCountry(cc, 'geo');
      })
      .catch(function () { /* unknown → stays UK (dual) */ });
  }

  /* ---------- wiring ---------- */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    /* microtask: lands before the next paint, so a re-rendered bare figure never shows */
    Promise.resolve().then(function () { queued = false; pass(); });
  }
  D.pass = pass;
  D.setCountry = setCountry;
  D.decorateSnize = doSnize;
  D.ready = true;
  html.classList.remove('dss-dual-failsafe');

  function start() {
    pass();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('variant:change', schedule);
    document.addEventListener('modalOpen', schedule);
    document.addEventListener('cart:updated', schedule);
    resolveCountry();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
